export default __webpack_public_path__ + "static/media/Steelspirit Chestguard.85e46d01.jpg";